/** @format */

import { ViewAllQuestionsMobileViewPropsType } from "../ViewAllQuestionsMobileViewPropsType";
import "../SCSS/styles.css";
import DOMPurify from "dompurify";
import { truncateString } from "../../Common/CommonFunctions/TruncateString";
import { EnumQuestionType } from "../../Common/Enums/EnumsTypes";

export default function ViewAllQuestionsMobileView({
  reducerState,
  questionObjVariable,
  handleQuestionsToRender,
  surveyAnswers,
}: ViewAllQuestionsMobileViewPropsType) {
  function questionTypes(questionId: string) {
    switch (questionObjVariable?.[questionId]?.questionType) {
      case EnumQuestionType.CHECKBOX:
        if (
          surveyAnswers[questionId]?.val &&
          Object.keys(surveyAnswers[questionId]?.val)?.length
        ) {
          return "view-all-questions-mobile-view-inner-wrapper";
        } else {
          return "view-all-questions-mobile-view-inner-wrapper-not-answered";
        }

      case EnumQuestionType.NUMBER:
        if (
          surveyAnswers[questionId]?.val &&
          surveyAnswers[questionId]?.val?.toString()?.length
        ) {
          return "view-all-questions-mobile-view-inner-wrapper";
        } else {
          return "view-all-questions-mobile-view-inner-wrapper-not-answered";
        }

      case EnumQuestionType.RATING:
      case EnumQuestionType.RADIO:
      case EnumQuestionType.DROP_DOWN:
      case EnumQuestionType.TEXT:
      case EnumQuestionType.TEXTAREA:
        if (
          surveyAnswers[questionId]?.val &&
          surveyAnswers[questionId]?.val?.length
        ) {
          return "view-all-questions-mobile-view-inner-wrapper";
        } else {
          return "view-all-questions-mobile-view-inner-wrapper-not-answered";
        }

      default:
        return "view-all-questions-mobile-view-inner-wrapper-not-answered";
    }
  }

  return (
    <div className="view-all-questions-mobile-view-main-container">
      {reducerState?.questionIdsToRender?.map(
        (questionId: string, index: number) => {
          return (
            <div
              className={questionTypes(questionId)}
              key={questionId}
              onClick={() => {
                handleQuestionsToRender(index);
              }}
            >
              <div className="view-all-main-question-mobile-view">
                <div className="view-all-serial-number">{index + 1}.</div>
                <div className="view-all-main-question-text-inner-container">
                  <div className="view-all-main-question-text">
                    <span> &nbsp;</span>
                    <span
                      className="view-all-question-text"
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(
                          questionObjVariable?.[questionId]?.question
                        ),
                      }}
                    ></span>
                  </div>
                  {questionObjVariable?.[questionId]?.validation?.mandatory
                    ?.isMandatory && (
                    <span className="view-all-question-text-is-mandatory">
                      (Mandatory)
                    </span>
                  )}

                  <div className="view-all-theme-category-cover">
                    {questionObjVariable?.[questionId]?.category && (
                      <div className="view-all-category-cover">
                        {truncateString(
                          questionObjVariable?.[questionId]?.category?.name ||
                            questionObjVariable?.[questionId]?.category,
                          30
                        )}
                      </div>
                    )}
                    {questionObjVariable?.[questionId]?.theme && (
                      <div className="view-all-theme-cover">
                        {truncateString(
                          questionObjVariable?.[questionId]?.theme,
                          30
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          );
        }
      )}
    </div>
  );
}
